import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PesquisaSatisfacaoSiteComponent } from 'app/pesquisa-satisfacao-site/pesquisa-satisfacao-site.component';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { MensagensService } from 'app/services/mensagens.service';
import { SiteService } from 'app/services/site.service';
import { ValidadorService } from 'app/services/validador.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';
import Swal from 'sweetalert2';
import { MinhaAreaSiteComponent } from 'app/minha-area-site/minha-area-site.component';
import { EventosService } from '../services/eventos.service';

@Component({
  selector: 'app-consulta-emprestimo',
  templateUrl: './consulta-emprestimo.component.html',
  styleUrls: ['./consulta-emprestimo.component.css']
})
export class ConsultaEmprestimoComponent implements OnInit, OnDestroy {
  idPensionista = 0;
  nomeUsuario = '';
  cpf = '';
  dados: any;
  @ViewChild(MinhaAreaSiteComponent) principal: MinhaAreaSiteComponent;

  constructor(
    private pageTitleService: PageTitleService,
    private formBuilder: FormBuilder,
    public validadorService: ValidadorService,
    public acessoRestritoSiteService: AcessoRestritoSiteService,
    public servico: SiteService,
    private eventosService: EventosService,
    public router: Router,
    private modalService: NgbModal,
    public mensagensService: MensagensService
  ) {
    this.pageTitleService.setTitle('Infomes');
    /* Page subTitle */
    this.pageTitleService.setSubTitle('');
    const usuario = JSON.parse(localStorage.getItem('localUsuarioDerminas'));
    if (!!usuario) {
      this.nomeUsuario = usuario.nomeUsuario;
      this.idPensionista = usuario.idPensionista;
      this.cpf = usuario.cpf;
    } else {
      this.router.navigate(['acesso-restrito']);
    }
  }

  ngOnInit(): void {
    this.acessoRestritoSiteService.emprestimo(this.cpf)
      .pipe(finalize(() => {
      }))
      .subscribe(result => {
        this.dados = result;
      },
        err => {
          const erro = this.mensagensService.recuperarMensagemErro(err);
          this.mensagensService.Error('Ocorreu um Erro!', erro);
        });
  }

  ngOnDestroy() {
  }

  sair() {
    this.eventosService.logout();
    localStorage.removeItem('localUsuarioDerminas');
    localStorage.removeItem('pesquisa');
    this.router.navigate(['acesso-restrito']);
  }

  voltar() {
    this.principal.voltando();
  }

}
